const locale = {
    placeholder: 'اختيار الوقت',
};
export default locale;
